// =======================================================
// IconDrawerMenuButton
// This is the button that triggers showing the Drawer Menu
// It is currently only visible on mobile (sizes a - c)
// =======================================================

import React, { useState } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useMyNotificationCount } from 'src/graphql/hooks'
import DrawerMenu from '../DrawerMenu'

// =======================================================
// Component
// =======================================================

const IconDrawerMenuButton = ({ display, horizontalPlacement }) => {
   const [menuVisibility, setMenuVisibility] = useState(false)
   const { notificationCount } = useMyNotificationCount()

   return (
      <>
         <View
            id="globalNavDrawerControlButton"
            display={display}
            onClick={() => setMenuVisibility(!menuVisibility)}
            onKeyPress={() => setMenuVisibility(!menuVisibility)}
            role="button"
            tabIndex={0}
            style={{ outline: 'none' }}>
            <View
               position="relative"
               float="left"
               display="flex"
               flexFlow="column"
               height="24px"
               width="24px"
               justifyContent="center"
               alignItems="center"
               style={{ cursor: 'pointer' }}>
               <View
                  flex="0 0 auto"
                  float="left"
                  width="18px"
                  height="2px"
                  backgroundColor="#888"
                  marginBottom="3px"
               />
               <View
                  flex="0 0 auto"
                  float="left"
                  width="18px"
                  height="2px"
                  backgroundColor="#888"
                  marginBottom="3px"
               />
               <View
                  flex="0 0 auto"
                  float="left"
                  width="18px"
                  height="2px"
                  backgroundColor="#888"
                  marginBottom="1px"
               />
               {notificationCount && (
                  <View
                     position="absolute"
                     top="-5px"
                     right="-10px"
                     display="flex"
                     justifyContent="center"
                     alignItems="center"
                     width="18px"
                     height="18px"
                     borderRadius="50%"
                     marginLeft="9px"
                     backgroundColor="#ff5c45">
                     <Text size="0.85" color="#fff">
                        {notificationCount}
                     </Text>
                  </View>
               )}
            </View>
         </View>
         <DrawerMenu
            horizontalPlacement={horizontalPlacement}
            visible={menuVisibility}
            onOverlayClick={() => setMenuVisibility(!menuVisibility)}
            onCloseButtonClick={() => setMenuVisibility(!menuVisibility)}
         />
      </>
   )
}

IconDrawerMenuButton.propTypes = {
   display: PropTypes.string,
   horizontalPlacement: PropTypes.oneOf(['left', 'right'])
}

IconDrawerMenuButton.defaultProps = {
   display: 'flex[a-c] none[d-f]',
   horizontalPlacement: undefined
}

export default IconDrawerMenuButton
